mutation RemoveMedia($clientId: ID!, $mediaIds: [ID]!) {
    removeMedia(clientId: $clientId, mediaIds: $mediaIds) {
        id
    }
}
